(function ($) {
    $(document).on("ready", function () {
        $("[data-action=toggle]")
            .on("click", function (e) {
                e.preventDefault();
                var trigger = $(e.currentTarget);
                var target = $(trigger.data("target"));
                target.each(
                    function (index, item) {
                        var $item = $(item);
                        var effect = target.attr("data-effect");
                        var hidden = $item.css("display") === "none" || $item.hasClass("off");
                        switch (effect) {
                            case "slide":
                                if (hidden) {
                                    $item.slideDown(200);
                                }
                                else {
                                    $item.slideUp(200);
                                }
                                break;
                            default:
                                if (hidden) {
                                    $item
                                        .removeClass("off")
                                        .addClass("on");

                                } else {
                                    $item
                                        .removeClass("on")
                                        .addClass("off");
                                }
                        }

                        if (hidden) {
                            trigger.addClass("active");
                        }
                        else {
                            trigger.removeClass("active");
                        }

                    }
                )

            });
    });
})(jQuery);